import styled from '@emotion/styled';
import { adColor } from '..';
import { PlacementType } from '../../../../../../modules/AnchorAPI/v3/episodes/saveAdCuePoints';

const CuePointTableWrapper = styled.div<{ hasRows: boolean }>`
  height: 334px;
  overflow-y: auto;
  background-color: ${({ hasRows }) => (hasRows ? '#ffffff' : '#ebeced')};
  h3,
  p {
    font-size: 1.4rem;
  }
`;

const CuePointTableContainer = styled.div`
  margin-bottom: 115px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  overflow: hidden;
`;

const CuePointTableDisabledAdsWarning = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 46px;
  border-top: 1px solid #d9d9d9;
  background-color: #f8f8f8;
  svg {
    width: 14px;
    height: 14px;
    margin-right: 10px;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 24px;
  font-size: 1.6rem;
`;

const Table = styled.table`
  width: 100%;
  table-layout: fixed;
  background-color: #ebeced;
  tbody {
    border-bottom: 1px solid #d9d9d9;
    background-color: #ffffff;
  }

  tr {
    height: 56px;
    border-bottom: 1px solid #d9d9d9;
  }
`;

const TableHeadRow = styled.tr`
  th {
    padding: 0 24px;
    font-weight: normal;
  }
`;

const TableBodyRow = styled.tr<{ isDisabled: boolean }>`
  &:last-of-type {
    border-bottom: none;
  }

  &:hover {
    background-color: #f9f9f9;
    cursor: pointer;
  }

  &:focus {
    outline: 1px dashed #8940fa;
  }

  td {
    padding: 13px 24px;

    &:last-of-type {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      height: 100%;
    }
  }

  ${({ isDisabled }) =>
    isDisabled &&
    `
    background-color: #f9f9f9;
    
    td:not(:last-of-type) {
      opacity: 0.5; 
    }

    &:hover {
      cursor: unset;
    }
  `}
`;

const AdId = styled.div<{ placementType: PlacementType }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  margin: 0;
  border-radius: 5px;
  color: #ffffff;
  background-color: ${({ placementType }) => adColor[placementType]};
`;

const EditLink = styled.a`
  margin-right: 10px;
  color: #5f6368;
  font-size: 1.4rem;
  cursor: pointer;

  &:hover {
    color: #5f6368;
  }

  &:focus {
    color: #8940fa;
  }
`;

const DisabledPill = styled.span`
  margin-right: 20px;
  padding: 4px 12px;
  border: 1px solid #5f6368;
  border-radius: 3px;
  font-weight: bold;
  font-size: 1.4rem;
  background: transparent;
`;

export {
  CuePointTableWrapper,
  CuePointTableContainer,
  CuePointTableDisabledAdsWarning,
  Container,
  Table,
  TableHeadRow,
  TableBodyRow,
  AdId,
  EditLink,
  DisabledPill,
};
